import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import '../../../src/App.css';
import './OlaSection.css';

import wave from '../../../src/assets/wave_40_opacity.png';
import openAI from '../../assets/logos_terceros/OpenAI.png';
import analytics from '../../assets/logos_terceros/adobe_analytics.png';
import jupyter from '../../assets/logos_terceros/jupyter.png';
import amazon from '../../assets/logos_terceros/amazon.png';
import apache from '../../assets/logos_terceros/Apache_Spark.png';
import azure from '../../assets/logos_terceros/azure.png';
import hadoop from '../../assets/logos_terceros/hadoop.png';
import launch from '../../assets/logos_terceros/launch.png';
import bi from '../../assets/logos_terceros/power_bi.png';
import react from '../../assets/logos_terceros/React.png';
import tableau from '../../assets/logos_terceros/tableau.png';
import gcloud from '../../assets/logos_terceros/Google_Cloud.png';
import tealium from '../../assets/logos_terceros/Tealium.png';
import python from '../../assets/logos_terceros/python.png';

const OlaSection = () => {
  return (
    <section
      className="ola-section"
      style={{ backgroundImage: `url(${wave})` }}
    >
      <Container className="">
        <Row className="text-center">
          <Col xs={12} lg={6} className="text-white">
            <div className='brand-container'>
              <p className="fs-1 font-nunito fw-bold overlay-text text-start">
                + de 50 tecnologías a <br/>
                <span>nuestro servicio</span>
              </p>
            </div>
          </Col>
          <Col xs={12} lg={6} className="d-flex align-items-center">
            <p className="fs-5 font-montserrat text-start lh-sm">
              Tenemos la experiencia para hacer que los datos trabajen<br/>
               para ti.<br />
              Llevamos más de una década ayudando a las empresas<br/>
              a crecer con soluciones de IA.
            </p>
          </Col>
        </Row>

        <Row className="logos-row col-lg-10 offset-lg-1">          
          <Col><img src={openAI} alt="OpenAI" className="logo_lg" /></Col>
          <Col><img src={analytics} alt="Adobe Analytics" className="logo_lg" /></Col>
          <Col><img src={apache} alt="Apache Spark" className="logo_md marginTop-10" /></Col>
          <Col><img src={hadoop} alt="Hadoop" className="logo_sm" /></Col>
          <Col><img src={jupyter} alt="jupyter" className="logo_sm" /></Col>
          <Col><img src={launch} alt="Launch" className="logo_sm" /></Col>
          <Col><img src={gcloud} alt="Google Cloud" className="logo_xxl" /></Col>
        </Row>
        <Row className="logos-row col-lg-10 offset-lg-1">
          <Col><img src={bi} alt="Power BI" className="logo_lg" /></Col>
          <Col><img src={react} alt="React" className="logo_xs" /></Col>
          <Col><img src={tableau} alt="Tableau" className="logo_xl paddingTop40px" /></Col>
          <Col><img src={azure} alt="Azure" className="logo_lg" /></Col>
          <Col><img src={amazon} alt="Amazon" className="logo_md" /></Col>
          <Col><img src={tealium} alt="Tealium" className="logo_lg" /></Col>
          <Col><img src={python} alt="Python" className="logo_xl" /></Col>
        </Row>
      </Container>
    </section>
  );
};

export default OlaSection;
